import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { VILLES, VILLE_SLUGS } from "@/data/ville_content";

const METIER_LIST = [
  { slug: "plombier", title: "Plombier", icon: "🔧" },
  { slug: "electricien", title: "Électricien", icon: "⚡" },
  { slug: "serrurier", title: "Serrurier", icon: "🔐" },
  { slug: "chauffagiste", title: "Chauffagiste", icon: "🔥" },
  { slug: "peintre", title: "Peintre", icon: "🎨" },
  { slug: "menuisier", title: "Menuisier", icon: "🪚" },
  { slug: "couvreur", title: "Couvreur", icon: "🏠" },
  { slug: "carreleur", title: "Carreleur", icon: "🧱" },
  { slug: "paysagiste", title: "Paysagiste", icon: "🌿" },
  { slug: "facadier", title: "Façadier", icon: "🏢" },
  { slug: "macon", title: "Maçon", icon: "🧱" },
  { slug: "vitrier", title: "Vitrier", icon: "🪟" },
  { slug: "platrier", title: "Plâtrier", icon: "🏗" },
  { slug: "ferblantier", title: "Ferblantier", icon: "🔩" },
  { slug: "photovoltaique", title: "Photovoltaïque", icon: "☀" },
  { slug: "renovation", title: "Rénovation", icon: "🏗" },
];

const FEATURED_VILLES = ["geneve", "lausanne", "fribourg", "sion", "montreux"];

export default function MetiersSection() {
  return (
    <section id="metiers" className="py-14 lg:py-24 bg-white border-t border-slate-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="section-label text-primary mb-4">Nos spécialités</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight">
            Solutions IA pour <span className="text-accent">chaque métier</span>
          </h2>
          <p className="text-base lg:text-lg text-slate-600 max-w-2xl mx-auto">
            Des pages dédiées pour chaque profession et chaque ville de Suisse romande.
          </p>
        </div>

        {/* Métiers grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 mb-10">
          {METIER_LIST.map((m) => (
            <Link
              key={m.slug}
              to={`/metier/${m.slug}`}
              data-testid={`metier-link-${m.slug}`}
              className="group flex flex-col items-center gap-2 bg-slate-50 border-2 border-slate-200 rounded-md p-3 hover:border-primary/40 hover:shadow-md transition-all text-center"
            >
              <span className="text-2xl">{m.icon}</span>
              <span className="text-xs font-semibold text-slate-700 group-hover:text-primary">{m.title}</span>
            </Link>
          ))}
        </div>

        {/* Featured villes */}
        <div className="bg-slate-50 border-2 border-slate-200 rounded-md p-6">
          <div className="flex items-center gap-2 mb-4">
            <MapPin className="w-4 h-4 text-accent" />
            <h3 className="text-sm font-bold text-slate-900">Disponible dans toute la Suisse romande</h3>
          </div>
          <div className="flex flex-wrap gap-2">
            {VILLE_SLUGS.map((slug) => {
              const v = VILLES[slug];
              return (
                <Link
                  key={slug}
                  to={`/metier/plombier/${slug}`}
                  data-testid={`ville-link-${slug}`}
                  className="inline-flex items-center gap-1.5 bg-white border border-slate-200 rounded-md px-3 py-1.5 text-xs font-medium text-slate-600 hover:border-primary/40 hover:text-primary transition-all"
                >
                  <img src={v.image} alt={v.nom} className="w-5 h-5 rounded object-cover" loading="lazy" />
                  {v.nom}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
